import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import Header from './components/Header';
import Footer from './components/Footer';
import routes from './routes';
import './styles/theme.css';
const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 600, // Faster animations
      once: true, // Prevent re-animations
      mirror: false, // Don’t animate on scroll up
    });
  }, []);

  // Small inner component so we can use useLocation (must be inside Router)
  const Main = () => {
    const location = useLocation();
    const isWelcome = location.pathname === '/';
    

    return (
      <>
        {!isWelcome && <Header />}
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
        {!isWelcome && <Footer />}
      </>
    );
  };

  return (
    <Router>
      <Main />
    </Router>
  );
};

export default App;